import axios from "axios";
import {
  generateAIVoice,
  generateAccentVoice,
  generateTranslationForText,
  generateVoiceForElevenLabs,
  generateVoiceForText,
  getAllElevenLabVoices,
  getAllElevenLabVoicesAccentedVoiceAPI,
  getAllSubtitle,
  getAllUserAudioScript,
} from "../../api/script";
import {
  getTranscriptBody,
  getVoiceGenerateBody,
} from "../../constants/apiRequestBody";
import {
  setChatGptData,
  setElevenLabVoices,
  setGenerateScriptModal,
  setSelectedSlideData,
  setUserAudioData,
  setSubtitles,
  setElevenLabsAccents,
  setElevenLabsAges,
  setElevenLabsGender,
} from "../../store/script/scriptSlice";

import { setIdle, setLoading } from "../../store/common/appStateSlice";
import { getFromLocal } from "../../utils/localStorage";
import { showToast } from "../../utils/general";

export const generateVoiceFromText = async (
  text,
  toLang,
  voice,
  userId,
  projectId,
  slideId,
  elevenLabs,
  isOpenAiVoice,
  isAccentVoice
) => {
  try {
    console.log("isOpenAiVoice (((", isOpenAiVoice);
    console.log("isAccentVoice ***", isAccentVoice);
    if (elevenLabs && !elevenLabs.languageId) {
      return showToast("Please select language", "", "danger");
    }
    let translatedText;
    if (!isOpenAiVoice && !isAccentVoice) {
      translatedText = await generateTranslationForText(
        getTranscriptBody(
          text,
          "en-US",
          elevenLabs ? elevenLabs.languageId.slice(0, 5) : toLang
        )
      );
    }
    let voiceFile;
    if (elevenLabs) {
      voiceFile = await generateVoiceForElevenLabs({
        voice_id: voice,
        text: translatedText,
        user_id: userId,
        project_id: projectId,
        slide_id: slideId,
      });
    } else if (isOpenAiVoice) {
      voiceFile = await generateAIVoice({
        voice_id: voice,
        text: text,
        user_id: userId,
        project_id: projectId,
        slide_id: slideId,
      });
    } else if (isAccentVoice) {
      voiceFile = await generateAccentVoice({
        gender: isAccentVoice?.gender,
        accent: isAccentVoice?.accent,
        age: isAccentVoice?.age,
        accent_strength: isAccentVoice?.range,
        text: text,
        user_id: userId,
        project_id: projectId,
        slide_id: slideId,
      });
    } else {
      voiceFile = await generateVoiceForText(
        getVoiceGenerateBody(userId, projectId, slideId, translatedText, voice)
      );
    }

    return { translatedText, voiceFile };
  } catch (error) {
    const customError =
      error?.response?.data?.error ||
      error?.message ||
      "Something wend wrong.!";
    showToast(customError, "", "danger");
    return { error: customError };
  }
};

export const generateTranscript = (body) => async (dispatch) => {
  try {
    await generateTranslationForText(body);
  } catch (error) {}
};

export const handleStepTwoSubmit =
  (formData, wordLimit = 600) =>
  async (dispatch, getState) => {
    dispatch(setLoading());
    const { slides, currentSlideIndex } = getState().slides;

    const messageContent = {
      messages: [
        {
          role: "user",
          content: `create slides presentation for the ${
            formData.videoTopic
          } in language ${"en-US".slice(0, 5)} with objective of ${
            formData.videoObjective
          } for ${formData.targetAudience} in ${
            formData.videoTone
          } tone and with ${formData.totalSlide || 1} number of slides ${
            wordLimit ? `with having maximum ${wordLimit} words each slide` : ""
          },
I want response in
[{
  "title": "Presentation Title",
  "content": "Presentation content goes here. It should be more than 300 characters long.",
  "bulletpoints": ["Key Point 1", "Key Point 2", "Key Point 3"]
}]`,
        },
      ],
      max_tokens: 2048,
      model: "gpt-3.5-turbo",
    };

    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        messageContent,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 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`,
            Accept: "application/json",
          },
        }
      );

      const data = response.data;

      if (data && data.choices && data.choices.length > 0) {
        const chatGptScript = JSON.parse(data.choices[0].message.content);
        const currentSlide = slides[currentSlideIndex];
        const isElevenLabs = currentSlide?.elevenlabs_voice;
        // assume language & voice will be same for all slides
        const currentSliceVoice = isElevenLabs
          ? isElevenLabs.languageId
          : currentSlide.voice;

        const formattedResponse = await Promise.all(
          chatGptScript.map(async (item, index) => {
            const mapCurrentSlide = slides?.[index];
            const mapIsElevenLabs = mapCurrentSlide?.elevenlabs_voice;
            return {
              ...item,
              originalScript: item.content,
              elevenLabVoice: mapIsElevenLabs,
              voice:
                (mapIsElevenLabs
                  ? mapIsElevenLabs?.languageId
                  : mapCurrentSlide?.voice) || currentSliceVoice,
            };
          })
        );

        dispatch(setChatGptData(formattedResponse));
        dispatch(setGenerateScriptModal(true));
        dispatch(setIdle());
      }
    } catch (error) {
      dispatch(setIdle());
      showToast("Something went wrong.!", "", "danger");
      console.log(error);
    }
  };

export const handleRegenerateChatGptResp =
  (formData) => async (dispatch, getState) => {
    dispatch(setLoading());
    const { slides, currentSlideIndex } = getState().slides;
    const { id } = getState().project;
    const userId = getFromLocal("userId");

    const messageContent = {
      messages: [
        {
          role: "user",
          content: `create slides presentation for the ${
            formData.videoTopic
          } in language ${"en-US".slice(0, 5)} with objective of ${
            formData.videoObjective
          } for ${formData.targetAudience} in ${
            formData.videoTone
          } tone and with ${
            formData.totalSlide || 1
          } number of slides with having maximum 500 words each slide,
   I want response in
   [{
    "title": "Presentation Title",
    "content": "Presentation content goes here. It should be more than 300 characters long.",
    "bulletpoints": ["Key Point 1", "Key Point 2", "Key Point 3"]
   }]`,
        },
      ],
      max_tokens: 2048,
      model: "gpt-3.5-turbo",
    };
    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        messageContent,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 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`,
            Accept: "application/json",
          },
        }
      );
      const data = response.data;
      if (data && data.choices && data.choices.length > 0) {
        const newData = JSON.parse(data.choices[0].message.content);
        const currentSliceVoice = slides[currentSlideIndex].voice;
        const toLang = currentSliceVoice.slice(0, 5);

        const formattedResponse = await Promise.all(
          newData.map(async (item, index) => {
            return {
              ...item,
              originalScript: item.content,
              voice: currentSliceVoice,
            };
          })
        );

        dispatch(setChatGptData(formattedResponse));
        dispatch(setIdle());
        // setIsApiRespLoading(false);
        dispatch(
          setSelectedSlideData({
            ...newData[0],
            currentSelectedSlide: 0,
          })
        );
      }
    } catch (error) {
      dispatch(setIdle());
      showToast("Something went wrong.!", "", "danger");
      console.log("error", error);
    }
  };

export const handleRegenerateSingleSlide = () => async (dispatch, getState) => {
  dispatch(setLoading());
  const { selectedSlideData } = getState().script;
  // setIsApiRespLoading(true);
  await axios
    .post(
      "https://api.openai.com/v1/chat/completions",
      {
        messages: [
          {
            role: "user",
            content: `regenerate below object with different content and bulletpoints with same title and current slide ${JSON.stringify(
              selectedSlideData
            )}`,
          },
        ],
        max_tokens: 2048,
        model: "gpt-3.5-turbo",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 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`,
          Accept: "application/json",
        },
      }
    )
    .then((data) => {
      if (data) {
        const newData = JSON.parse(data.data.choices[0].message.content);
        dispatch(setSelectedSlideData(newData));
        dispatch(
          updateSpecificSlide(selectedSlideData.currentSelectedSlide, newData)
        );

        dispatch(setIdle());
      }
    })
    .catch((err) => {
      dispatch(setIdle());
      console.log(err);
    });
};

export const updateSpecificSlide =
  (updateIndex, newData) => async (dispatch, getState) => {
    // Create a copy of the current chatGptData array
    const { chatGptData } = getState().script;
    const updatedData = [...chatGptData];

    // Update the specific slide at the given index
    updatedData[updateIndex] = {
      currentSelectedSlide: updateIndex,
      bulletpoints: newData.bulletpoints,
      content: newData.content,
      title: newData.title,
    };

    // Update the state with the modified array
    dispatch(setChatGptData(updatedData));
  };

export const getUserAudioScript = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const userId = getFromLocal("userId");
    const response = await getAllUserAudioScript(userId || 637);
    console.log("response", response);
    dispatch(setUserAudioData(response));
    dispatch(setIdle());
  } catch (error) {
    dispatch(setIdle());
    console.log("error", error);
  }
};

export const getElevenLabsVoices = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await getAllElevenLabVoices();
    const formattedResponse = response.voices.map((res) => ({
      ...res,
      id: res.voiceId,
      ...res.labels,
    }));
    dispatch(setElevenLabVoices(formattedResponse));
    dispatch(setIdle());
  } catch (error) {
    dispatch(setIdle());
    console.log("error", error);
  }
};

export const getAllElevenLabVoicesAccentedVoice = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await getAllElevenLabVoicesAccentedVoiceAPI();

    console.log("response", response);
    // const formattedResponse = response.voices.map((res) => ({
    //   ...res,
    //   id: res.voiceId,
    //   ...res.labels,
    // }));
    // dispatch(setElevenLabVoices(formattedResponse));
    dispatch(setElevenLabsAges(response?.ages));
    dispatch(setElevenLabsAccents(response?.accents));
    dispatch(setElevenLabsGender(response?.genders));
    dispatch(setIdle());
  } catch (error) {
    dispatch(setIdle());
    console.log("error", error);
  }
};
export const getSubtitles = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await getAllSubtitle();
    dispatch(setSubtitles(response?.data || []));
    dispatch(setIdle());
  } catch (error) {
    dispatch(setIdle());
    console.log("error", error);
  }
};

// export const handleAIVoice = () => async (dispatch, getState) => {
//   try {
//     const { slides, currentSlideIndex } = getState().slides;
//     const { openAiVoiceId } = getState().slides;
//     console.log("openAiVoiceId", openAiVoiceId);
//     const userId = getFromLocal("userId");
//     const { id } = getState().project;
//     const data = {
//       voice_id: openAiVoiceId,
//       text: slides[currentSlideIndex].originalScript,
//       user_id: userId,
//       project_id: id,
//       slide_id: currentSlideIndex,
//     };
//     const response = await generateAIVoice(data);
//     console.log("response", response);
//   } catch (error) {
//     console.log("error", error);
//   }
// };
